// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1XDF_","head":"Table_head__pGviN","col":"Table_col__Cag2J"};